import React from "react";
import styled from "styled-components";


const CardStyle = styled.div `
.card {
    transform-style: preserve-3d;
    transition: transform 0.5s linear;
    width: 283px;
    height: 380px;
  }

  .card-box {
    width: auto;
    height: auto;
  }

  .front, .back {
    width:95%;
    height: 95%;
    backface-visibility: hidden;
    
  }

  .back{
    transform: rotateY(180deg);
    align-text:center;
  }

  .card-box:hover .card {
    transform: rotateY(180deg);
  }

  @media (max-width: 570px) {
    .card {
      width: 100%;
      width: 283px;
      height: 380px;
    } 

    .card-box {
      width: 100%;
      height: 100%;
    }
  }
`

function IconFlipcard({flipcard}) {

  return (
    <div className="w-full">
      <CardStyle>
      <div className="card-box">
        <div className='relative mx-auto card flex flex-col text-center items-center justify-center'>
          <div className="front absolute transform shadow-xl rounded-lg bg-white flex flex-col p-6 ">
            <div className="w-full h-2/3">
              <img alt='flipcard' className="mx-auto object-contain mt-10 w-32 h-32 sm:w-40 sm:h-40" src={flipcard.icon}></img>
            </div>
            <h1 className="text-lpGray font-medium">{flipcard.title}</h1>
            <p className="text-sm ">{flipcard.subtitle}</p>
          </div>
          <div className="back flex flex-col absolute shadow-xl rounded-lg bg-primary">
            <div className="back-content p-6 sm:p-8 text-left transform ">
              <h1 className="text-lg font-semibold text-white">{flipcard.title}</h1>
              <p className="text-sm text-white">{flipcard.subtitle}</p>
              <p className="text-base text-white pt-4">{flipcard.content}</p>
            </div>
          </div>
        </div>
      </div>
      
    </CardStyle>
    </div>
    
    
  )
  
}

export default IconFlipcard;